<template>
  <div>
    <validation-provider
      name="Apelido"
      :rules="{ required: true }"
      v-slot="validationContext"
    >
      <b-form-group label="Apelido" label-for="surname">
        <b-form-input
          id="surname"
          name="surname"
          v-model="value.surname"
          :state="validateState(validationContext)"
        ></b-form-input>
      </b-form-group>
    </validation-provider>
    <b-row>
      <b-col md="6">
        <validation-provider
          name="Email"
          :rules="{ required: true }"
          v-slot="validationContext"
        >
          <b-form-group label="Email" label-for="email">
            <b-form-input
              id="email"
              name="email"
              type="email"
              v-model="value.email"
              :state="validateState(validationContext)"
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col md="6">
        <validation-provider
          name="Telefone"
          :rules="{ required: true }"
          v-slot="validationContext"
        >
          <b-form-group label="Telefone" label-for="phone">
            <b-form-input
              id="phone"
              name="phone"
              type="text"
              v-model="value.phone"
              :state="validateState(validationContext)"
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <validation-provider
      name="Morada"
      :rules="{ required: true }"
      v-slot="validationContext"
    >
      <b-form-group label="Morada" label-for="address">
        <b-form-input
          id="address"
          name="address"
          v-model="value.address"
          :state="validateState(validationContext)"
        ></b-form-input>
      </b-form-group>
    </validation-provider>
    <b-row>
      <b-col md="6">
        <validation-provider
          name="Código Postal"
          :rules="{ required: true }"
          v-slot="validationContext"
        >
          <b-form-group label="Código Postal" label-for="zip_code">
            <b-form-input
              id="zip_code"
              name="zip_code"
              v-model="value.zip_code"
              :state="validateState(validationContext)"
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col md="6">
        <validation-provider
          name="Localidade"
          :rules="{ required: true }"
          v-slot="validationContext"
        >
          <b-form-group label="Localidade" label-for="locality">
            <b-form-input
              id="locality"
              name="locality"
              v-model="value.locality"
              :state="validateState(validationContext)"
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  name: "MainForm",
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  watch: {
    value() {
      this.$emit("input", this.value);
    },
  },
  methods: {
    validateState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
  },
};
</script>
